import { GetStaticProps } from 'next';
import { NextSeo } from 'next-seo';
import Head from 'next/head';

import {
  getAllCategories,
  getAllPosts,
  getAllTags,
  getPostBySlug,
  getTagsByPost,
} from '@lib/wordpress';
import { Category, Post, Tag } from '@lib/wordpress.d';
import { BlogDetails } from '@modules/blog/details/BlogDetails';
import {
  getSEOPostCanonical,
  getSEOPostDesc,
  getSEOPostTitle,
} from '@modules/blog/util';

interface Props {
  post: Post;
  categories: Category[];
  postTags: Tag[];
  allTags: Tag[];
  posts: Post[];
}

export default function Page({ post, postTags, allTags, categories }: Props) {
  if (!post) return null;
  const TITLE = getSEOPostTitle({ post });
  const DESC = getSEOPostDesc({ post });
  const UPDATED_URL = getSEOPostCanonical({ post });
  console.log(UPDATED_URL);
  return (
    <>
      <Head>
        <link rel="canonical" key="canonical" href={UPDATED_URL} />
        <link rel="alternate" hrefLang="en" href={UPDATED_URL} />
      </Head>
      <NextSeo
        title={TITLE}
        description={DESC}
        canonical={UPDATED_URL}
        openGraph={{
          url: UPDATED_URL,
          title: TITLE,
          description: DESC,
        }}
      />
      <BlogDetails
        post={post}
        postTags={postTags}
        allTags={allTags}
        categories={categories}
      />
    </>
  );
}

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const post: Post = await getPostBySlug(params?.query as string);
  const postTags = await getTagsByPost(post.id);
  const allTags = await getAllTags();

  const categories = await getAllCategories();
  return {
    props: {
      post,
      postTags,
      allTags,
      categories,
    },
    revalidate: 600, // Revalidate every 10 minutes (600 seconds)
  };
};

export const getStaticPaths = async () => {
  const posts = await getAllPosts();
  let paths: any = [];
  if (posts && posts?.length > 0) {
    paths = posts.map((post: any) => ({
      params: { query: post.slug },
    }));
  }
  return {
    paths,
    fallback: 'blocking', // Use blocking fallback for better SEO and UX
  };
};
